module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"TutorSpace","short_name":"TutorSpace","start_url":"/","background_color":"#FFE81D","theme_color":"#FFE81D","display":"minimal-ui","icon":"src/assets/icons/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"156a904bf80ba08635bf578cc36e3245"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
